<template>
	<div class="vue-admin-beautiful-wrapper"> 
		<div class="vab-main">
			<!-- <div style="height: 10px"></div> -->
			<vab-app-main />
		</div>

		<footers></footers>
		
	</div>
</template>

<script>
	import {
		mapActions,
		mapGetters
	} from 'vuex'
	import vabNavBar from "./components/VabNavBar/index.vue"
	import VabAppMain from "./components/VabAppMain/index.vue"
	import footers from "@/components/foot/footer.vue";
	export default {
		name: 'Layout',
		components: {
			"vab-nav-bar": vabNavBar,
			"vab-app-main": VabAppMain,
			footers: footers,
		},
		data() {
			return {
				oldLayout: ''
			}
		},
		computed: {
			classObj() {
				return {
					mobile: this.device === 'mobile',
				}
			},
		},
		beforeMount() {
			window.addEventListener('resize', this.handleResize)
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.handleResize)
		},
		mounted() {
		
		},
		methods: {
			handleIsMobile() {
				return document.body.getBoundingClientRect().width - 1 < 992
			},
			handleResize() {
				if (!document.hidden) {
					// const isMobile = this.handleIsMobile()
					// if (isMobile) {
					//   //横向布局时如果是手机端访问那么改成纵向版
					//   this.$store.dispatch('settings/changeLayout', 'vertical')
					// } else {
					//   this.$store.dispatch('settings/changeLayout', this.oldLayout)
					// }

					// this.$store.dispatch(
					//   'settings/toggleDevice',
					//   isMobile ? 'mobile' : 'desktop'
					// )
				}
			},
		},
	}
</script>
<style>
	.layout-container-topheader-horizontal .vab-main .vab-main-right .el-scrollbar__wrap {
		margin-left: 10px;
		height: calc(100vh - 47px);
	}
</style>
<style lang="scss" scoped>
	.vue-admin-beautiful-wrapper {
		width: 100%;
		min-height: 100vh;
	}
	.vab-main{
		min-height: calc(100vh );
	}
</style>



// WEBPACK FOOTER //
// index.vue?06092213